<template>
  <el-pagination
    v-if="dataSource.totalCount"
    background
    :total="dataSource.totalCount"
    :page-sizes="[15, 30, 50, 100]"
    :page-size="dataSource.pageSize"
    :current-page.sync="dataSource.pageNo"
    layout="prev, pager, next, jumper,total"
    @size-change="handlePageSizeChange"
    @current-change="handlePageNoChange"
    style="text-align: right"
  ></el-pagination>
</template>

<script setup>
const props = defineProps({
  dataSource: {},//数据
  fetch: Function, // 获取数据的函数
});

//初始化
const init = () => {
  if (props.initFetch && props.fetch) {
    props.fetch();
  }
}
init();

//切换每页大小
const handlePageSizeChange = (size) => {
  props.dataSource.pageSize = size;
  props.dataSource.pageNo = 1;
  props.fetch();
};
// 切换页码
const handlePageNoChange = (pageNo) => {
  props.dataSource.pageNo = pageNo;
  props.fetch();
};
</script>

<style scoped></style>
